import request from "@/utils/request";

export function getCommittees(companyId) {
  return request({
    url: "/committees",
    method: "get",
    params: {
      company: companyId,
    },
  });
}

export function getCommittee(id) {
  return request({
    url: `/committees/${id}`,
    method: "get",
  });
}

export function createCommittee(data) {
  return request({
    url: "/committees",
    method: "post",
    data,
  });
}

export function updateCommittee(id, data) {
  return request({
    url: `/committees/${id}`,
    method: "put",
    data,
  });
}

export function deleteCommittee(id) {
  return request({
    url: `/committees/${id}`,
    method: "delete",
  });
}

export function getCommitteeEvents(id) {
  return request({
    url: `/committees/${id}/events`,
    method: "get",
  });
}
